var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminprofileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0202 36.3201C37.8758 36.3201 39.3802 34.8158 39.3802 32.9601C39.3802 31.1044 37.8758 29.6001 36.0202 29.6001C34.1645 29.6001 32.6602 31.1044 32.6602 32.9601C32.6602 34.8158 34.1645 36.3201 36.0202 36.3201Z",
    fill: "#5C5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1399 38.24C33.9499 38.24 29.5699 39.32 29.4199 41.48C30.9199 43.61 33.3799 44.99 36.1399 44.99C38.8999 44.99 41.3599 43.61 42.8599 41.48C42.7099 39.32 38.3299 38.24 36.1399 38.24Z",
    fill: "#5C5C5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5998 21.1868V9.04045L19.6998 0.800049L0.799805 9.04045V21.4136C0.799805 32.8544 8.8638 43.5644 19.6998 46.16C21.0858 45.8324 22.4214 45.3537 23.7318 44.7741C26.4534 48.6549 30.9642 51.2 36.0798 51.2C44.421 51.2 51.1998 44.4212 51.1998 36.08C51.1998 28.5956 45.7566 22.3964 38.5998 21.1868ZM20.9598 36.08C20.9598 37.4912 21.1614 38.8773 21.5394 40.1625C20.9346 40.4397 20.3298 40.7168 19.6998 40.9184C11.7114 38.3984 5.8398 30.2336 5.8398 21.4136V12.3416L19.6998 6.29365L33.5598 12.3416V21.1868C26.403 22.3964 20.9598 28.5956 20.9598 36.08ZM36.0798 46.16C30.5106 46.16 25.9998 41.6492 25.9998 36.08C25.9998 30.5108 30.5106 26 36.0798 26C41.649 26 46.1598 30.5108 46.1598 36.08C46.1598 41.6492 41.649 46.16 36.0798 46.16Z",
    fill: "#5C5C5C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminprofileIcon);
export default __webpack_public_path__ + "static/media/adminprofile_icon.6d54bf03f1a3f66ec03ce5acdd18deca.svg";
export { ForwardRef as ReactComponent };